import GuaranteeDeliveryInfoLayer from "./GuaranteeDeliveryInfoLayer";

/**
 * @export
 * @class DeliveryBanners
 * 배송정보 안내 배너
 */
export default class DeliveryBanners {
  constructor() {
    // 필요 data 유효 확인
    const {
      bIsDeliveryDeal,
      htDealInfo: { deliveryInfo },
    } = TMON.oApp.htStorage.htStaticData;
    if (
      !bIsDeliveryDeal ||
      (!deliveryInfo && Object.keys(deliveryInfo).length < 1)
    )
      return;

    this.welWrapper = $("#_deliveryBanners");

    this.setEvent();
    this.render();

    this.oGuaranteeDeliveryInfoLayer = null;
  }

  setEvent() {
    // 책임배송정보 레이어 열기 eventListener 등록
    this.welWrapper.on(
      "click",
      "[data-role=btnShowGuaranteeDelivery]",
      this.handleShowGuaranteeDeliveryInfoLayer
    );
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off("click", "[data-role=btnShowGuaranteeDelivery]");
    }

    if (
      this.oGuaranteeDeliveryInfoLayer &&
      this.oGuaranteeDeliveryInfoLayer.clearEvent
    ) {
      this.oGuaranteeDeliveryInfoLayer.clearEvent();
    }
  }

  /**
   * 책임배송정보 레이어 열기 eventListener
   */
  handleShowGuaranteeDeliveryInfoLayer = () => {
    if (!this.oGuaranteeDeliveryInfoLayer) {
      this.oGuaranteeDeliveryInfoLayer = new GuaranteeDeliveryInfoLayer();
    }

    this.oGuaranteeDeliveryInfoLayer.open();
  };

  render() {
    const {
      isNotGuaranteeDeal,
      htDealInfo: { deliveryInfo, contentInfo = {} },
    } = TMON.oApp.htStorage.htStaticData;

    let hideDeliveryBannerInfo = false; // 배송정보 배너 숨김 여부
    if (contentInfo && Object.keys(contentInfo).length > 0) {
      ({ hideDeliveryBannerInfo = false } = contentInfo);
    }

    // 배송정보 배너 보임 여부
    const bShowDeliveryBanner =
      !hideDeliveryBannerInfo && // 배송정보 배너 숨기지 않음
      deliveryInfo.htRefinedDeliveryInfo &&
      deliveryInfo.htRefinedDeliveryInfo.deliveryBanner; // 정제된 배송정보가 있음

    const { deliveryBanner } = deliveryInfo.htRefinedDeliveryInfo;

    const sHtml = `
            ${
              bShowDeliveryBanner
                ? `<button type="button" class="ct_wrp item"${
                    deliveryInfo.htRefinedDeliveryInfo
                      .sDeliveryBannerButtonDataRole
                      ? ` data-role="${
                          deliveryInfo.htRefinedDeliveryInfo
                            .sDeliveryBannerButtonDataRole
                        }"`
                      : ""
                  }>
                        <strong class="tit_bn ${
                          deliveryInfo.htRefinedDeliveryInfo.icon
                        }">
                            ${deliveryInfo.htRefinedDeliveryInfo.title}
                        </strong>
                        <div class="txt_area">${deliveryBanner}</div>
                    </button>`
                : ""
            }
            ${
              !isNotGuaranteeDeal && deliveryInfo.dutyDeliveryRefund
                ? `<button type="button" data-role="btnShowGuaranteeDelivery" class="ct_wrp item" data-tlarea="PDB0" data-tlord="1">
                        <strong class="tit_bn ico_delivery">책임배송제</strong>
                        <div class="txt_area">
                            <p><strong>결제일+2일 이내 (주말, 공휴일 제외) 상품을 받지 못하신 경우</strong> 티몬 적립금으로 보상해 드립니다. <i class="go" /></p>
                        </div>
                    </button>`
                : ""
            }
        `;

    if ($.trim(sHtml) === "") {
      this.welWrapper.hide();
    } else {
      this.welWrapper.html(sHtml);
    }
  }
}
